<template>
    <div class="Index-header">
        <div class="Index-header-c">
            <img src="../../assets/images/logo.png" class="logo"/>
            <div class="header-item" v-for="(item,index) in itemList" @click="selectItem(item)"
                 @mouseover="mouseover(item)">{{item.title}}
            </div>
        </div>
        <div class="item-list" v-if="isShow">
            <div class="item-list-content" @mouseleave="mouseLeave">
                <div class="item-list-content_left">
                    <div class="item-list-content_left-item" v-for="(item,index) in childrenList"
                         @mouseover="childrenMouseover(index)">
                        <div style="margin-left: 20px;">{{item.title}}</div>
                    </div>
                </div>
                <div class="item-list-content_right" v-if="childrenList.length>0">
                    <div class="header-item-div" v-for="item in childrenList[selectChildrenIndex].children">
                        <p style="text-align: left;font-weight: bold;font-size: 18px;cursor: pointer;"
                           @click="openPage(item.name)">{{item.title}}</p>
                        <p style="text-align: left;margin-top: 10px;color: #78787a;">{{item.desc}}</p>
                    </div>
                    <div style="width: 100%;height: 20px;"
                         v-if="childrenList.length>0 && childrenList[selectChildrenIndex].children.length>0"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {getRouterList} from '../../assets/js/utils.js'

    export default {
        data() {
            return {
                itemList: [],
                childrenList: [],
                itemIndex: 0,
                selectChildrenIndex: 0,
                isShow: false
            }
        },
        created() {
            //this.itemList = this.$router.options.routes;
            this.getList();
        },
        methods: {
            childrenMouseover(index) {
                this.selectChildrenIndex = index;
            },
            getList() {
                this.itemList = getRouterList();
            },
            selectItem(item) {
                console.log(item);
                if (item.children.length <= 0) {
                    this.$router.push({name: item.name});
                }
            },
            mouseover(val) {
                let self = this;
                console.log(val.children);
                this.childrenList = val.children;
                if (val.children.length > 0) {
                    this.isShow = true;
                } else {
                    this.isShow = false;
                }
                this.itemList.forEach(function (item, index) {
                    if (item.name == val.name) {
                        self.itemIndex = index;
                    }
                })
            },
            mouseLeave() {
                this.childrenList = [];
                this.isShow = false;
            },
            openPage(name) {
                console.log(name);
                this.$router.push({name: name});
            }
        }
    }
</script>

<style>
    * {
        margin: 0;
    }

    .Index-header {
        width: 100%;
        height: 70px;
        background: #ffffff;
        box-shadow: 0 0 50px rgb(0 0 0 / 5%);
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 10001;
    }

    .logo {
        height: 40px;

    }

    .Index-header-c {
        width: 1080px;
        text-align: left;
        margin: auto;
        display: flex;
        align-items: center;
    }

    .header-item {
        margin-left: 30px;
        font-size: 18px;
        color: #323233;
        cursor: pointer;
    }

    .item-list {
        position: fixed;
        top: 70px;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(0, 0, 0, 0.3);
    }

    .item-list-content {
        width: 100%;
        height: 0px;
        position: fixed;
        top: 70px;
        animation: myfirst 0.8s;
        -webkit-animation: myfirst 0.8s;
        animation-fill-mode: forwards; /*当动画完成时，动画会停留在最后一帧。*/
        overflow: hidden;
        background: #ffffff;
        display: flex;
    }

    @keyframes myfirst /* Safari and Chrome */
    {
        from {
            height: 0px
        }
        to {
            height: auto;
        }
    }

    .item-list-content_left {
        width: 200px;
    }

    .item-list-content_right {
        flex: 1;
        margin-left: 20px;
    }

    .header-item-div {
        width: 33.1%;
        float: left;
        padding: 30px 0px;
    }

    .item-list-content_left-item {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;

    }

    .item-list-content_left-item:hover {
        background: rgba(255, 72, 0, 0.2);
    }
</style>